import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../services/apiServices";

// Fetch brands
export const fetchBrands = createAsyncThunk("brands/fetchBrands", async (_, { rejectWithValue }) => {
  try {
    const response = await apiServices.get("brands");
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Error fetching brands");
  }
});

// Add a brand
export const addBrand = createAsyncThunk("brands/addBrand", async (brandData, { rejectWithValue }) => {
  try {
    const response = await apiServices.post("brands", brandData);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Error adding brand");
  }
});

export const updateBrand = createAsyncThunk("brands/updateBrand", async ({ brandId, brandData }, { rejectWithValue }) => {
  try {
    const response = await apiServices.put(`brands/${brandId}`, brandData);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Error updating brand");
  }
});
// Delete a brand
export const deleteBrand = createAsyncThunk("brands/deleteBrand", async (id, { rejectWithValue }) => {
  try {
    await apiServices.delete(`brands/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Error deleting brand");
  }
});

const brandSlice = createSlice({
  name: "brands",
  initialState: {
    brands: [],
    status: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch brands
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.brands = action.payload;
        state.error = null;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.brands = [];
      })

      // Update brand
      .addCase(updateBrand.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.brands = state.brands.map((brand) =>
          brand._id === action.payload._id ? action.payload : brand
        );
        state.error = null;
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add brand
      .addCase(addBrand.fulfilled, (state, action) => {
        state.brands.unshift(action.payload);
        state.status = "succeeded";
        state.error = null;
      })

      // Delete brand
      .addCase(deleteBrand.fulfilled, (state, action) => {
        state.brands = state.brands.filter((brand) => brand._id !== action.payload);
        state.status = "succeeded";
        state.error = null;
      });
  },
});

export default brandSlice.reducer;
